/*/*import { headerController } from "./header";*/
import { footerController } from "./footer";
import { editController } from "./edit";
import { previewController } from "./preview";
import { util, response, cmnPart } from "./index";
import  * as es6promise from "es6-promise";
import { hagakiSelectController } from "./hagakiSelect";
import { atenaSelectController } from "./atenaSelect";
import { addOrderController } from "./addOrder";
import { Logger } from "./util/logger";
import { ajax } from "sonbp/util/index";
import { common } from "./util/common";
import { errorController } from "./error";
import { SSO } from "./util/sso";

module posca {

	/**
	 * スタートポイント
	 * */
	export function startup() {
		// 遷移先判定
		const locationNow: string = location.href;
		const locationNowSplit1: string[] = locationNow.split("/");
		const locationNowSplit2: string[] = locationNowSplit1[locationNowSplit1.length - 1].split("?");

		if (0 < locationNowSplit2.length) {
			// ログ初期化
			Logger.init();

			// 遷移先ページ名取得
			const pageName: string = locationNowSplit2[0].toLocaleLowerCase();

			// リテーラ別情報の取得
			GetRetailerConfig().then((resData: cmnPart.commonPartInitEntity) => {

				// タイトル設定
				if (resData.retailerConfig.pageTitle) {
					$("#ratailerTitle").text(resData.retailerConfig.pageTitle);
				}

				// Vueコントローラの初期化
				InitController(pageName, resData);
			});
		}
		else {
			// 該当なし -> エラー画面へ
			Logger.log("遷移先ページ該当なし location.href[" + location.href + "]");
		}

	}

	/**
	 * リテーラ別情報の取得
	 * */
	async function GetRetailerConfig(): es6promise.Promise<cmnPart.commonPartInitEntity> {

		let retailerConfig: cmnPart.commonPartInitEntity; 

		await util.ajax.post("Style/GetRetailerConfig", "").then((resData: cmnPart.commonPartInitEntity) => {
			retailerConfig = resData;

			Logger.warn("リテーラ別情報", retailerConfig);

		}, () => {
				retailerConfig = null;
		});

		return retailerConfig

	}

	/**
	 * Vueコントローラの初期化
	 * @param pageName
	 * @param initEntity
	 */
	function InitController(pageName: string, initEntity: cmnPart.commonPartInitEntity): boolean {

		// PCサイト？
		const usePcDesign: boolean = util.ui.usePcDesign();

		// エラーページか?
		let isError = false;

		// staticモジュールに設定を渡す。
		util.ajax.returnTop = initEntity.retailerConfig.returnTop;
		common._retailerConf = initEntity.retailerConfig;
		common.init();

		SSO.SetRetailerSetting(initEntity.retailerConfig);
		SSO.init();

		// 遷移先ページ名に対応する、コントローラを生成
		if (pageName === "edit") {
			// 編集画面
			let controller: editController;
			controller = new editController();
			controller.ScreenCtrl = initEntity.screenCtrl;
			controller.RetailerConfig = initEntity.retailerConfig;
			controller.PutRange = initEntity.putRange;
			controller.PutRangeStamp = initEntity.putRangeStamp;
			if (usePcDesign) {
				// sonbpのオフセットはPC版のみ
				controller.PageAreaOffset = initEntity.pageAreaOffset;
			} else {
				const obj = {
					x: 0,
					y: 0
				} as cmnPart.AreaCoordinate;
				controller.PageAreaOffset = obj;
			}
			controller.UsePcDesign = usePcDesign;
			controller.init();
		}
		else if (pageName === "preview") {
			// プレビュー画面
			let controller: previewController;
			controller = new previewController();
			controller.RetailerConfig = initEntity.retailerConfig;
			controller.UsePcDesign = usePcDesign;
			controller.init();
		}
		else if (pageName === "hagakiselect") {
			// はがき種/枚数選択画面
			let controller: hagakiSelectController;
			controller = new hagakiSelectController();
			controller.RetailerConfig = initEntity.retailerConfig;
			controller.UsePcDesign = usePcDesign;
			controller.init();
		}
		else if (pageName === "atenaselect") {
			// 宛名選択画面
			let controller: atenaSelectController;
			controller = new atenaSelectController();
			controller.RetailerConfig = initEntity.retailerConfig;
			controller.UsePcDesign = usePcDesign;
			controller.init();

			// GIGYA WebView版用にコントローラをグローバルにおいておく。
			(<any>window).AtenaController = controller;
		}
		else if (pageName === "addorder") {
			// 追加注文画面
			let controller: addOrderController;
			controller = new addOrderController();
			controller.RetailerConfig = initEntity.retailerConfig;
			controller.UsePcDesign = usePcDesign;
			controller.init();

			// GIGYA WebView版用にコントローラをグローバルにおいておく。
			(<any>window).AddController = controller;
		}
		else {

			isError = true;

			// エラー画面へ
			let controller: errorController;
			controller = new errorController();
			controller.RetailerConfig = initEntity.retailerConfig;
			controller.UsePcDesign = usePcDesign;
			controller.init();
		}

		if (usePcDesign && !isError) {
			//// PC用
			//// 共通ヘッダー初期化
			//let header = new headerController();
			//header.RetailerConfig = initEntity.retailerConfig;
			//header.init();

			// 共通フッター初期化
			let footer = new footerController();
			footer.RetailerConfig = initEntity.retailerConfig;
			footer.init();
		}
		else {
			// SP用
			// SPは各画面で実装です。
		}

		return true;
	}

}

posca.startup();
